import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export interface CenterState {
    id: number,
    refetch: boolean,
}
const initialState: CenterState = {
    id: 0,
    refetch: false,
}

export const centerSlice = createSlice({
    name: 'center',
    initialState,
    reducers: {
        setId(state, action: PayloadAction<number>) {
            state.id = action.payload;
        },
        setRefetch(state, action: PayloadAction<boolean>) {
            state.refetch = action.payload;
        },
    },
})
export const { setId, setRefetch} = centerSlice.actions

export default centerSlice.reducer